import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { Configuration } from "../../../api";

export enum CardExportStatus {
  Pending = 0,
  Running = 1,
  Completed = 2,
  Failed = 3,
  Cancelled = 4,
}

export interface CardExportJob {
  id: string;
  createdAt: string;
  startedAt: string | null;
  completedAt: string | null;
  status: CardExportStatus;
  totalCount: number;
  processedCount: number;
  failedCount: number;
  description: string | null;
  errorMessage: string | null;
  fileSize: number | null;
  downloadUrl: string | null;
}

export interface CreateCardExportRequest {
  eupId: string;
  /** Zaznaczone karty; puste = wszystkie karty spełniające filtry */
  kpoIds?: string[];
  cardNumber?: string;
  wasteCode?: string;
  registrationNumber?: string;
  senderName?: string;
  additionalInfo?: string;
  startTransportDate?: Date;
  endTransportDate?: Date;
  year?: number;
}

@Injectable({ providedIn: "root" })
export class CardExportService {
  constructor(private http: HttpClient, private configuration: Configuration) {}

  create(request: CreateCardExportRequest): Observable<CardExportJob> {
    return this.http.post<CardExportJob>(this.url("/api/CardExport"), request, { headers: this.headers() });
  }

  getAll(): Observable<CardExportJob[]> {
    return this.http.get<CardExportJob[]>(this.url("/api/CardExport"), { headers: this.headers() });
  }

  cancel(id: string): Observable<void> {
    return this.http.delete<void>(this.url(`/api/CardExport/${id}`), { headers: this.headers() });
  }

  /** Pobranie bezpośrednio przez przeglądarkę - duże archiwa nie są ładowane do pamięci strony */
  download(job: CardExportJob): void {
    if (!job.downloadUrl) return;
    const link = document.createElement("a");
    link.href = this.url(job.downloadUrl);
    link.dispatchEvent(new MouseEvent("click", { bubbles: true, cancelable: true, view: window }));
    link.remove();
  }

  private url(path: string): string {
    return (this.configuration.basePath || "") + path;
  }

  private headers(): HttpHeaders {
    let headers = new HttpHeaders();
    const authorization = this.configuration.apiKeys?.["Authorization"];
    if (authorization) headers = headers.set("Authorization", authorization);
    return headers;
  }
}
